import React from "react";
import eventStyles from "../styles/EventsAndWebinars.module.css";
import Navigation from "../components/Navbar";
import Footer from "../components/Footer";
import Seo from "../components/Seo";

const EventsAndWebinars = () => {
  const calendly = "https://calendly.com/cloudare";

  const webinars = [
    {
      id: 1,
      title: "Solving European e-Invocing with MAROSA",
      subtitle: "Marosa x Cloudare",
      videoId: "1T754fxwFn8",
      date: "On-Demand Webinar",
      duration: "45 mins",
      category: "Compliance",
      description:
        "Cloudare and Marosa provide a solution for European e-invoicing compliance. It covers the challenges businesses face such as regulatory complexity, transmission requirements, and different reporting models, and explains how their API-based connector integrates ERP systems with e-invoicing platforms to enable real-time data exchange, validation, and compliance.",
      highlights: [
        "Regulatory complexity solutions",
        "API-based connector integration",
        "Real-time data exchange & validation",
        "Global mandates timeline",
        "Automation benefits for business operations",
      ],
      speakers: [
        {
          name: "Sailesh Arya", // Sailesh Arya CEO
          role: "Founder and CEO - Cloudare Technologies",
        },
        {
          name: "Matt Ayton",
          role: "Sales Engineer - Marosa",
        },
      ],
    },
    {
      id: 2,
      title: "Driving Compliance Together",
      subtitle: "ecosio x Cloudare",
      videoId: "ki9OnKCtohU",
      date: "On-Demand Webinar",
      duration: "60 mins",
      category: "Compliance",
      description:
        "This Webinar covers e-invoicing concepts, global mandates, and how ecosio and Cloudare provide a connector solution to help businesses achieve compliance. It covers what e-invoicing is, PEPPOL models, country-specific regulations (Europe and UAE), benefits of automation, and an implementation roadmap for integrating e-invoicing with ERP systems.",
      highlights: [
        "E-invoicing concepts explained",
        "PEPPOL models overview",
        "Europe & UAE regulations",
        "ERP integration roadmap",
        "Automation benefits & ROI",
      ],
      speakers: [
        {
          name: "Sailesh Arya",
          role: "Founder and CEO - Cloudare Technologies",
        },
        {
          name: "Debora Pereira",
          role: "Partner Manager - Ecosio",
        },
      ],
    },
    {
      id: 3,
      title: "Preparing your ERP, Controls & People for UAE e-Invoicing",
      subtitle: "Covoro x Cloudare",
      videoId: "hu3SRN6SDt4", // Add YouTube video ID here if available
      date: "On-Demand Webinar",
      duration: "45 mins",
      category: "Compliance",
      description:
        "The webinar “Before the Mandate Hits: Preparing Your ERP, Controls & People for UAE E-Invoicing” was a joint initiative by Cloudare and Covoro, focused on helping businesses get ready for the upcoming UAE e-invoicing mandate. It covered the regulatory overview, implementation timeline, and key compliance requirements, along with how organizations should align their ERP systems, processes, and teams. The session also highlighted the role of automation and Agentic AI in enabling accurate, efficient, and compliant e-invoicing. Overall, the webinar provided a practical roadmap for businesses to proactively prepare and ensure smooth compliance.",
      highlights: [
        "UAE e-invoicing regulatory overview",
        "Implementation timeline & compliance requirements",
        "ERP system readiness & alignment",
        "Process & team preparedness",
        "Role of automation & Agentic AI",
        "Practical roadmap for compliance",
      ],
      speakers: [
        {
          name: "Sailesh Arya",
          role: "Founder and CEO - Cloudare Technologies",
        },
        {
          name: "Aman Gupta",
          role: "E-Invoicing Specialist - Covoro",
        },
      ],
    },
    {
      id: 4,
      title: "UAE e-Invoicing: Compliance & Implementation Readiness",
      subtitle: "Cygnet.One x Cloudare",
      videoId: "cuTojtaq3tw",
      date: "On-Demand Webinar",
      duration: "60 mins",
      category: "Compliance",
      description:
        "UAE e-Invoicing is more than a regulatory requirement. It will fundamentally change how invoicing processes work across ERP systems, validations, and reporting workflows. This practical webinar, hosted by Cloudare and Cygnet.One, provides a structured understanding of UAE e-Invoicing from both compliance and implementation perspectives. The session explains how organizations can prepare their systems, workflows, and teams without disrupting business continuity, while also showcasing a live portal demonstration of the end-to-end e-invoicing process.",
      highlights: [
        "ERP to tax authority invoice data flow",
        "Workflow and approval process changes",
        "ERP integration readiness strategies",
        "Common implementation challenges & solutions",
        "Step-by-step end-to-end e-invoicing walkthrough",
        "Live portal demonstration",
      ],
      speakers: [
        {
          name: "Sailesh Arya",
          role: "Founder & CEO - Cloudare Technologies",
        },
        {
          name: "Maunish Shah",
          role: "AVP : Products, Cygnet.One",
        },
        {
          name: "Reshma Pillai",
          role: "Subject Matter Expert, Cygnet.One",
        },
      ],
    },
  ];

  return (
    <div className={eventStyles.container}>
        <Seo path="/events-and-webinars" />
      <Navigation />
      {/* Hero Section */}
      <section className={eventStyles.heroSection}>
        <div className={eventStyles.heroOverlay}></div>
        <div className={eventStyles.heroContent}>
          <span className={eventStyles.heroBadge}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polygon points="23 7 16 12 23 17 23 7"></polygon>
              <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
            </svg>
            Events & Webinars
          </span>
          <h1 className={eventStyles.heroTitle}>
            Learn from Industry
            <span className={eventStyles.heroHighlight}> Experts</span>
          </h1>
          <p className={eventStyles.heroSubtitle}>
            Join our exclusive webinars and events to stay ahead in e-invoicing
            compliance, ERP integration, and digital transformation.
          </p>
          <div className={eventStyles.heroStats}>
            <div className={eventStyles.statItem}>
              <span className={eventStyles.statNumber}>3+</span>
              <span className={eventStyles.statLabel}>Webinars</span>
            </div>
            <div className={eventStyles.statDivider}></div>
            <div className={eventStyles.statItem}>
              <span className={eventStyles.statNumber}>150+</span>
              <span className={eventStyles.statLabel}>Attendees</span>
            </div>
            <div className={eventStyles.statDivider}></div>
            <div className={eventStyles.statItem}>
              <span className={eventStyles.statNumber}>6+</span>
              <span className={eventStyles.statLabel}>Expert Speakers</span>
            </div>
          </div>
        </div>
        <div className={eventStyles.heroDecoration}>
          <div className={eventStyles.decorCircle1}></div>
          <div className={eventStyles.decorCircle2}></div>
          <div className={eventStyles.decorCircle3}></div>
        </div>
      </section>

      {/* Featured Webinars Section */}
      <section className={eventStyles.webinarsSection}>
        <div className={eventStyles.sectionHeader}>
          <span className={eventStyles.sectionTag}>Featured Content</span>
          <h2 className={eventStyles.sectionTitle}>On-Demand Webinars</h2>
          <p className={eventStyles.sectionDescription}>
            Watch our recorded sessions anytime and gain valuable insights into
            e-invoicing compliance and integration strategies.
          </p>
        </div>

        <div className={eventStyles.webinarsGrid}>
          {webinars.map((webinar) => (
            <div key={webinar.id} className={eventStyles.webinarCard}>
              <div className={eventStyles.videoContainer}>
                <div className={eventStyles.videoWrapper}>
                  <iframe
                    src={`https://www.youtube.com/embed/${webinar.videoId}?rel=0&modestbranding=1`}
                    title={webinar.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className={eventStyles.videoFrame}
                  ></iframe>
                </div>
                <div className={eventStyles.videoBadge}>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                  YouTube
                </div>
              </div>

              <div className={eventStyles.cardContent}>
                <div className={eventStyles.cardMeta}>
                  <span className={eventStyles.categoryBadge}>
                    {webinar.category}
                  </span>
                  <span className={eventStyles.duration}>
                    {/* <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg> */}
                    {/* {webinar.duration} */}
                  </span>
                </div>

                <h3 className={eventStyles.cardTitle}>{webinar.title}</h3>
                <p className={eventStyles.cardSubtitle}>{webinar.subtitle}</p>
                <p className={eventStyles.cardDescription}>
                  {webinar.description}
                </p>

                {/* <div className={eventStyles.highlightsSection}>
                  <h4 className={eventStyles.highlightsTitle}>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <polyline points="9 11 12 14 22 4"></polyline>
                      <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                    </svg>
                    Key Topics Covered
                  </h4>
                  <ul className={eventStyles.highlightsList}>
                    {webinar.highlights.map((highlight, index) => (
                      <li key={index} className={eventStyles.highlightItem}>
                        <span className={eventStyles.checkIcon}>✓</span>
                        {highlight}
                      </li>
                    ))}
                  </ul>
                </div> */}

                <div className={eventStyles.speakersSection}>
                  <h4 className={eventStyles.speakersTitle}>
                    Featured Speakers
                  </h4>
                  <div className={eventStyles.speakersList}>
                    {webinar.speakers.map((speaker, index) => (
                      <div key={index} className={eventStyles.speakerItem}>
                        <div className={eventStyles.speakerAvatar}>
                          {speaker.name.charAt(0)}
                        </div>
                        <div className={eventStyles.speakerInfo}>
                          <span className={eventStyles.speakerName}>
                            {speaker.name}
                          </span>
                          <span className={eventStyles.speakerRole}>
                            {speaker.role}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* <div className={eventStyles.cardActions}>
                  <a
                    href={`https://www.youtube.com/watch?v=${webinar.videoId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={eventStyles.watchButton}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <polygon points="5 3 19 12 5 21 5 3"></polygon>
                    </svg>
                    Watch on YouTube
                  </a>
                  <button className={eventStyles.shareButton}>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <circle cx="18" cy="5" r="3"></circle>
                      <circle cx="6" cy="12" r="3"></circle>
                      <circle cx="18" cy="19" r="3"></circle>
                      <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                      <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                    </svg>
                    Share
                  </button>
                </div> */}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className={eventStyles.ctaSection}>
        <div className={eventStyles.ctaContent}>
          <h2 className={eventStyles.ctaTitle}>
            Want to Host a Webinar With Us?
          </h2>
          <p className={eventStyles.ctaDescription}>
            Partner with Cloudare Technologies to share your expertise and reach
            a wider audience. Let's create impactful content together.
          </p>
          <div className={eventStyles.ctaButtons}>
            <a
              href={calendly}
              target="_blank"
              rel="noopener noreferrer"
              className={eventStyles.ctaPrimary}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              Book a Free Consultation
            </a>
            <a href="/about" className={eventStyles.ctaSecondary}>
              Learn More
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </a>
          </div>
        </div>
        <div className={eventStyles.ctaDecoration}>
          <div className={eventStyles.ctaCircle1}></div>
          <div className={eventStyles.ctaCircle2}></div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default EventsAndWebinars;
